import { parseForce } from "../../utils/units.js";

class LoadDialogComponent extends HTMLElement {

  tensileLoad = '2'
  shearXLoad = '2'
  shearYLoad = '2'

  constructor() {
    super()
    document.addEventListener('project-loaded', async (event) => this.onProjectLoaded(event.detail.load), true)
    this.addEventListener('show.bs.modal', this.configure)
  }

  /**
   * Create our view model and configure the view
   * @param {Load} model
   * 
   */
   onProjectLoaded(model) {
    this.tensileLoad = `${model.tensileLoad}`
    this.shearXLoad = `${model.shearXLoad}`
    this.shearYLoad = `${model.shearYLoad}`
    //this.configure()
    //this.publishUpdate()
  }

  configure() {
    document.getElementById('tensile-load-input').value = this.tensileLoad
    document.getElementById('shear-x-load-input').value = this.shearXLoad
    document.getElementById('shear-y-load-input').value = this.shearYLoad
  }

  publishUpdate() {
    const event = new CustomEvent('load-dialog-update', { detail: this });
    this.dispatchEvent(event)
  }

  onTensileLoadBlur() {
    const value = parseForce(document.getElementById("tensile-load-input").value)
    if(isNaN(value)) {
      document.getElementById('tensile-load-validation').classList.remove('d-none')
      return
    }
    document.getElementById('tensile-load-validation').classList.add('d-none') 
    this.tensileLoad = document.getElementById('tensile-load-input').value
    this.publishUpdate()
  }

  onShearXBlur() {
    const value = parseForce(document.getElementById("shear-x-load-input").value)
    if(isNaN(value)) {
      document.getElementById('shear-x-load-validation').classList.remove('d-none')
      return
    }
    document.getElementById('shear-x-load-validation').classList.add('d-none') 
    this.shearXLoad = document.getElementById('shear-x-load-input').value
    this.publishUpdate()
  }

  onShearYBlur() {
    const value = parseForce(document.getElementById("shear-y-load-input").value)
    if(isNaN(value)) {
      document.getElementById('shear-y-load-validation').classList.remove('d-none')
      return
    }
    document.getElementById('shear-y-load-validation').classList.add('d-none') 
    this.shearYLoad = document.getElementById('shear-y-load-input').value
    this.publishUpdate()
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-load-dialog" tabindex="-1" role="dialog" aria-labelledby="myModalShapeLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Specify Anchor Bolt Loads</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="bs-component">
              <!-- Table -->
              <form id="load-form">
                <div>
                  <table class="table">
                    <tr>
                      <td style="width:120px;">Tension (kips)</td>
                      <td><input style="width:100px;" id="tensile-load-input" type="text" name="tension-load"
                          class="text-center" value="${this.tensileLoad}" />
                          <div  style="width:200px;" id="tensile-load-validation" class="alert alert-danger d-none">
                            Please enter a valid load. e.g. 5 or 5 kips
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="width:120px;">Shear X (kips)</td>
                      <td><input style="width:100px;" id="shear-x-load-input" type="text" name="shear-x-load"
                      class="text-center" value="${this.shearXLoad}" />
                      <div  style="width:200px;" id="shear-x-load-validation" class="alert alert-danger d-none">
                        Please enter a valid load. e.g. 5 or 5 kips
                      </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="width:120px;">Shear Y (kips)</td>
                      <td><input style="width:100px;" id="shear-y-load-input" type="text" name="shear-y-load"
                      class="text-center" value="${this.shearYLoad}" />
                      <div  style="width:200px;" id="shear-y-load-validation" class="alert alert-danger d-none">
                        Please enter a valid load. e.g. 5 or 5 kips
                      </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>`

    document.getElementById('tensile-load-input').onblur = (() => this.onTensileLoadBlur())
    document.getElementById('shear-x-load-input').onblur = (() => this.onShearXBlur())
    document.getElementById('shear-y-load-input').onblur = (() => this.onShearYBlur())

    this.configure()
  }
}

customElements.define('load-dialog-component', LoadDialogComponent)













